// Shared by field and comment writes so both use the revision returned by the previous write.
export const createDirectReportQueue = (initialRevision: number) => {
  let revision = initialRevision;
  let tail: Promise<unknown> = Promise.resolve();
  let pending = 0;
  return {
    syncRevision(next: number) {
      if (!pending) revision = next;
    },
    enqueue<T extends { revision: number }>(send: (revision: number) => Promise<T>): Promise<T> {
      pending++;
      const task = tail.then(async () => {
        try {
          const result = await send(revision);
          revision = result.revision;
          return result;
        } finally {
          pending--;
        }
      });
      tail = task.catch(() => undefined);
      return task;
    },
  };
};
